/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/**
 * Marketing Division Class receives variable data then transmits to backend.
 */
export class MarketingDivisionModel {
  marketDivision: string;
  userNetId: string;
}
